var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class, _temp;

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';

var TabsTabpanel = (_temp = _class = function (_Component) {
    _inherits(TabsTabpanel, _Component);

    function TabsTabpanel() {
        _classCallCheck(this, TabsTabpanel);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    TabsTabpanel.prototype.render = function render() {
        var _props = this.props,
            className = _props.className,
            children = _props.children,
            forceRender = _props.forceRender,
            id = _props.id,
            selected = _props.selected,
            selectedClassName = _props.selectedClassName,
            tabId = _props.tabId,
            attributes = _objectWithoutProperties(_props, ['className', 'children', 'forceRender', 'id', 'selected', 'selectedClassName', 'tabId']);

        return React.createElement(
            'div',
            _extends({}, attributes, {
                className: className, role: 'tabpanel',
                id: id,
                'aria-labelledby': tabId,
                'aria-selected': selected ? 'true' : 'false',
                key: this.props.index
            }),
            this.props.children
        );
    };

    return TabsTabpanel;
}(Component), _class.defaultProps = {
    className: "admin-tabs__tabpanel",
    forceRender: false
}, _temp);
TabsTabpanel.propTypes = process.env.NODE_ENV !== "production" ? {
    children: PropTypes.node,
    forceRender: PropTypes.bool,
    id: PropTypes.string, // private
    selected: PropTypes.bool, // private
    selectedClassName: PropTypes.string,
    tabId: PropTypes.string // private
} : {};


export default TabsTabpanel;